import React, { useEffect, useState } from "react";
import { Container, Col, Row, Modal, ModalHeader, ModalBody } from "reactstrap";
import Styles from "./rewards.module.css";
import img_recompense from "../../img/spa_recompense.jpeg";
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import Axios from "axios";

const Rewards = () => {
  const [isLoading, setisLoading] = useState(true);
  const [datas, setDatas] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    getInfos();
    getDisabled(datas);
  });

  const putScore0 = async (e) => {
    e.preventDefault();
    try {
      const uuid = window.localStorage.getItem("uuid");
      await Axios.put(`https://squicker.herokuapp.com/patients/${uuid}`, {
        score: 0,
      });
      toggle();
    } catch (err) {
      console.log(err);
    }
  };

  const getInfos = async () => {
    try {
      const uuid = window.localStorage.getItem("uuid");
      const res = await Axios.get(
        `https://squicker.herokuapp.com/patients/${uuid}`
      );
      setDatas(res.data.score);
      setisLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getDisabled = (scorePatient) => {
    if (scorePatient === 4) {
      setIsDisabled(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <p>loading</p>
      ) : (
        <Container>
          <Row>
            <Col lg={{ size: 8, offset: 2 }}>
              <Row>
                <Col>
                  <Link className={Styles.linkStyle} to="/dashboard">
                    <FaArrowCircleLeft />
                  </Link>
                  <h2>Vos récompenses</h2>
                </Col>
              </Row>
              <Row className="justify-content-center m-5">
                <p>
                  Votre assiduité vous permettra de developper des récompenses !
                </p>
              </Row>
              <Row className="bg-light my-3">
                <Col lg="6" xs="12">
                  <img width="100%" src={img_recompense} alt="spa" />
                </Col>
                <Col lg="6" xs="12" className="align-self-center">
                  <Container>
                    <h3>Spa Dune & eau</h3>
                    <p className="lead">
                      -10% sur ton entrée au spa de labenne, venez profiter d'un
                      moment de détente !
                    </p>
                    {isDisabled ? (
                      <button disabled className={Styles.generalButtonDisabled}>
                        Utiliser le coupon
                      </button>
                    ) : (
                      <>
                        <button
                          className={Styles.generalButton}
                          onClick={putScore0}
                        >
                          Utiliser le coupon
                        </button>
                        <Modal isOpen={modal} toggle={toggle}>
                          <ModalHeader toggle={toggle}>Code Promo</ModalHeader>
                          <ModalBody>
                            <h2>Squirel10</h2>
                            <p className={Styles.message}>
                              A utiliser sur le site internet{" "}
                              <a href="https://www.duneeteau.fr/">
                                Spa Dune et Eau
                              </a>
                            </p>
                          </ModalBody>
                        </Modal>
                      </>
                      // <button className={Styles.generalButton}>
                      //   Utiliser le coupon
                      // </button>
                    )}
                  </Container>
                </Col>
              </Row>
              <Row className="bg-light my-3">
                <Col lg="6" xs="12">
                  <img width="100%" src={img_recompense} alt="spa" />
                </Col>
                <Col lg="6" xs="12" className="align-self-center">
                  <Container>
                    <h3>Spa Dune & eau</h3>
                    <p className="lead">
                      -10% sur ton entrée au spa de labenne, venez profiter d'un
                      moment de détente !
                    </p>
                    <button disabled className={Styles.generalButtonDisabled}>
                      Utiliser le coupon
                    </button>
                  </Container>
                </Col>
              </Row>
              <Row className="bg-light my-3">
                <Col lg="6" xs="12">
                  <img width="100%" src={img_recompense} alt="spa" />
                </Col>
                <Col lg="6" xs="12" className="align-self-center">
                  <Container>
                    <h3>Spa Dune & eau</h3>
                    <p className="lead">
                      -10% sur ton entrée au spa de labenne, venez profiter d'un
                      moment de détente !
                    </p>
                    <button disabled className={Styles.generalButtonDisabled}>
                      Utiliser le coupon
                    </button>
                  </Container>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default Rewards;
